import React, { useEffect, useRef, useState } from "react";
import { Suggestion } from "@fdoh/health-ui-react/build/ts/components/FormControl/FormControlUserSelect.types";
import { FormControl, Card, Layout, Button, usePath, Page, ApiEndpoint, useAppConfig } from "@fdoh/health-ui-react";
import { useHistory, Link, useLocation } from "react-router-dom";
import { useSubmitForm } from "../../hooks/useSubmitForm";
import { useForm } from "react-hook-form";
import { useData, usePostForm } from "../../hooks";
import { yupResolver } from "@hookform/resolvers/yup";
import CSS from 'csstype';
import { Constants, InspectionStatus } from "../../helpers/Constants";
import { SubmitInspectionFormProps, SubimtInspectionInput, schema, JsonData, ProviderData } from "./SubmitInspection.types";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";
import { string } from "yup";
import usePostFileForm from "../../hooks/usePostFileForm";
import useClient from "../../hooks/useInspectionClient";
import { data } from "jquery";
import { toast } from "react-toastify";
import { ApplicationDetails, ApplicationInspection } from "../Components/Home/ApplicationDetails.types";
import { DateTime } from "@fdoh/health-react";
import useProfile from "../../hooks/useProfile";
import { UserSecurityInput } from "../../components/DBProtectedRoute.types";
import html2canvas from "html2canvas";
import { jsPDF } from 'jspdf';


export const SubmitInspectionForm = (props: SubmitInspectionFormProps) => {
    const history = useHistory();
    const client = useClient();
    const ProviderData = useData<ProviderData[]>("userSecurity") || [];
    // Change state to arrays for multiple files (File[])
    const [inspectionFiles, setInspectionFiles] = useState<File[]>([]);
    const [sealedCertificationFiles, setSealedCertificationFiles] = useState<File[]>([]);
    const [isInspectionFileValid, setIsInspectionFileValid] = useState(true);
    const [isSealedCertificationFileValid, setIsSealedCertificationValid] = useState(true);
    const [inspectFileError, setInspectionFileError] = useState("");
    const [sealedCertificationFileError, setSealedCertificationFileError] = useState("");
    const [addComments, setComments] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const path = usePath();
    const [appInspectionCompliance, setItems] = useState<any>([]);
    const today = new Date().toISOString().split('T')[0];
    // Add state for mutual file requirement error
    const [atLeastOneFileRequiredError, setAtLeastOneFileRequiredError] = useState("");

    const config = useAppConfig();
    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];
    const user = useProfile(application) as UserSecurityInput;
    const toggle = (event: any) => {

        if (event === 'approve') {
            setFlag('approve');
            setValue("isApproved", true)
        } else {
            setFlag('disapprove');
            setValue("isApproved", false)
        }
    }
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const applicationInfoId = JSON.parse(searchParams.get("applicationId") || '{}');
    const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');

    const applicationInspectionData = useData<ApplicationInspection>('SummaryView/' + inspectionId);   

    const applicationDetails = useData<ApplicationDetails>('Application/' + applicationInfoId);
    const applicationData = applicationDetails?.permitDate?.toString().split("T")[0];
    const entityId = afterLast(applicationDetails?.permitNumber, '-');


    // const permitDate = DateTime.
    const { control, handleSubmit, setValue, watch } = useForm<SubimtInspectionInput>({
        defaultValues: {
            ...props.values
        },
        resolver: yupResolver(schema(applicationData))
    });

    const [flag, setFlag] = useState(control?._formValues?.isApproved || false ? 'approve' : 'disapprove');

    const p1Styles: CSS.Properties = {
        // float: "right",
        marginLeft: '60px'
    };
    
    const formRef = useRef<HTMLFormElement>(null);

    function timeout(delay: number) {
        return new Promise(res => setTimeout(res, delay));
    }
    function afterLast(value: any, delimiter: any) {
        value = value || ''

        return delimiter === ''
            ? value
            : value.split(delimiter).pop()
    }
    // function getLastHyphen(str: string): string { const parts = str.split("-"); return parts[parts.length - 1]; }
    // Add helper to sanitize file names
    function sanitizeFileName(name: string): string {
        // Allow only letters, numbers, hyphens, underscores, dots, and spaces
        return name.replace(/[^\w\s.-]/g, '');
    }
    // Update saveFile to use sanitizeFileName for file names
    const saveFile = (e: any, type: string) => {
        const files: File[] = Array.from(e.target.files as FileList);
        if (type === "inspection") {
            setInspectionFiles(files);
            setValue("inspectionFileName", files.map(f => sanitizeFileName(f.name)).join(", "));
        } else {
            setSealedCertificationFiles(files);
            setValue("engineerSealedCertificate", files.map(f => sanitizeFileName(f.name)).join(", "));
        }
    };

    const onSubmit = useSubmitForm<SubimtInspectionInput>(
        'applicationInspection',
        (response) => history.push(
            {
                pathname: "/summaryView/",
                search: `?applicationId=${applicationInfoId}&inspectionId=${inspectionId}`,
            }),
        props.action
    );

    //const applicationInspectionData = useData<ApplicationInspection>('InspectionDetails/GetInspection/' + inspectionId);

    const formatData = (resJson: any) => {
        const reskeys = Object.keys(resJson);
        let finalData = reskeys.reduce((prev: any, curr: any) => {
            let newRows: any = [];
            const itemKeys = Object.keys(resJson[curr]);
            if (itemKeys.length > 0) {
                newRows = itemKeys.map(itemKey => {
                    return { key1: curr, keys2: itemKey, value: resJson[curr][itemKey] }
                })
            }
            return [...prev, ...newRows]
        }, [])
        setItems(finalData);
    }
    const fetchData = async () => {
        try {
            let endpoint = `InspectionDetails/GetInspection/${inspectionId}`;
            const response = await client.api(endpoint).get();
            formatData(response.data)
            console.log('fetchData response', response)
        } catch (error: any) {
            toast.error(`Failed to load inspection data: ${error.message || 'Unknown error occurred'}`);
        }
    }

    useEffect(() => {
        fetchData();
    }, [])

    // Update validate to check all files
    const validate = () => {
        let isValid = true;
        setAtLeastOneFileRequiredError(""); // reset
        // Require at least one file
        if (inspectionFiles.length === 0 && sealedCertificationFiles.length === 0) {
            setAtLeastOneFileRequiredError("You must upload at least one Inspection or Sealed Certification file.");
            isValid = false;
        }
        // Inspection files
        if (inspectionFiles.length > 0) {
            let allValid = true;
            for (const file of inspectionFiles) {
                if (file.size / 1024 > 10240) {
                    setIsInspectionFileValid(false);
                    setInspectionFileError("Inspection File should be less than 10MB");
                    isValid = false;
                    allValid = false;
                    break;
                }
                const allowedTypes = [
                    "application/pdf",
                    "image/png",
                    "image/jpeg",
                    "image/jpg",
                    "image/gif",
                    "image/bmp",
                    "image/tiff",
                    "image/tif"
                ];
                if (!allowedTypes.includes(file.type)) {
                    setIsInspectionFileValid(false);
                    setInspectionFileError("Inspection File must be .pdf, .png, .jpg, .jpeg, .gif, .bmp, .tiff, or .tif");
                    isValid = false;
                    allValid = false;
                    break;
                }
            }
            if (allValid) setIsInspectionFileValid(true);
        }
        // Sealed certification files
        if (sealedCertificationFiles.length > 0) {
            let allValid = true;
            for (const file of sealedCertificationFiles) {
                if (file.size / 1024 > 10240) {
                    setIsSealedCertificationValid(false);
                    setSealedCertificationFileError("Sealed Certification File should be less than 10MB");
                    isValid = false;
                    allValid = false;
                    break;
                }
                const allowedTypes = [
                    "application/pdf",
                    "image/png",
                    "image/jpeg",
                    "image/jpg",
                    "image/gif",
                    "image/bmp",
                    "image/tiff",
                    "image/tif"
                ];
                if (!allowedTypes.includes(file.type)) {
                    setIsSealedCertificationValid(false);
                    setSealedCertificationFileError("Sealed Certification File must be .pdf, .png, .jpg, .jpeg, .gif, .bmp, .tiff, or .tif");
                    isValid = false;
                    allValid = false;
                    break;
                }
            }
            if (allValid) setIsSealedCertificationValid(true);
        }
        return isValid;
    };

    // New uploadFiles function for multiple files in one request
    const uploadFiles = async (files: File[], type: string) => {
        const formData = new FormData();
        files.forEach(file => {
            // Use sanitized file name when appending
            const sanitizedName = sanitizeFileName(file.name);
            const sanitizedFile = new File([file], sanitizedName, { type: file.type });
            formData.append('files', sanitizedFile);
        });
        formData.append('EntityId', entityId); // entityId from your context
        formData.append('FileType', type);

        return new Promise<any[]>((resolve, reject) => {
            fileUploadCallback(formData, (response: any) => {
                if (response && typeof response === 'string') {
                    try {
                        const parsedResponse = JSON.parse(response);
                        if (Array.isArray(parsedResponse)) {
                            resolve(parsedResponse);
                        } else if (parsedResponse.success !== false) {
                            resolve([parsedResponse]);
                        } else {
                            const errorMessage = parsedResponse?.message || parsedResponse?.error || 'File upload failed';
                            reject(new Error(errorMessage));
                        }
                    } catch {
                        // If response is not JSON, treat it as success
                        resolve([response]);
                    }
                } else if (response && response.success !== false) {
                    resolve([response]);
                } else {
                    const errorMessage = response?.message || response?.error || 'File upload failed';
                    reject(new Error(errorMessage));
                }
            });
        });
    };

    const DownloadFile = async (fileName: string, filePath: string) => {
        const options = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Basic ${btoa(application.apiKey)}`
            }
        };

        //' const  filepath = "";
        let endpoint = 'ApplicationInspection/GetFileById';
        let path = `${application.baseUrl}/ApplicationInspection/GetFileById/` + fileName + "?uploadPath=" + filePath;
        const response = await fetch(path, options)

            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    a.click();
                });

            });

    }
    const downloadPdfDocument = () => {
        const input = document.getElementById('root');
        html2canvas(document.body)
            .then((canvas: any) => {
                var imgData = canvas.toDataURL('image/png');
                var imgWidth = 210; var pageHeight = 295;
                var imgHeight = canvas.height * imgWidth / canvas.width;
                var heightLeft = imgHeight;
                var doc = new jsPDF('p', 'mm');
                var position = 0;
                doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    doc.addPage();
                    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                }
                doc.save('PermitNumber_' + applicationInspectionData?.application.permitNumber + '.pdf');

            })
    }

    // Update finalSubmit to use uploadFiles for all files in one request per type
    const finalSubmit = async (data: SubimtInspectionInput) => {
        setIsSubmitting(true);
        try {
            // Upload all inspection files in one request (only if new files are selected)
            if (inspectionFiles.length > 0) {
                try {
                    const inspectionFileResponse = await uploadFiles(inspectionFiles, "inspection");
                    // Sanitize file names in stored responses too (in case needed)
                    const sanitizedNames = inspectionFileResponse.map((file: any) => sanitizeFileName(String(file))).join(", ");
                    setValue("inspectionFileName", sanitizedNames);
                    setValue("inspectionFilePath", `wwwroot\\inspectionFileUploads\\`);
                    data = {
                        ...data,
                        inspectionFileName: applicationInspectionData?.inspectionFileName ? applicationInspectionData?.inspectionFileName + ", " + sanitizedNames : sanitizedNames,
                        inspectionFilePath: `wwwroot\\inspectionFileUploads\\`
                    };
                } catch (error: any) {
                    const errorMessage = error.message || error.error || 'Failed to upload inspection file';
                    toast.error(errorMessage, { autoClose: 5000 });
                    setIsSubmitting(false);
                    return;
                }
            }
            else if (applicationInspectionData?.inspectionFileName) {
                // If no new files are selected but existing files exist, keep the existing data
                data = {
                    ...data,
                    inspectionFileName: applicationInspectionData.inspectionFileName,
                    inspectionFilePath: applicationInspectionData.inspectionFilePath || `wwwroot\\inspectionFileUploads\\`
                };
            }

            // Upload all sealed certification files in one request (only if new files are selected)
            if (sealedCertificationFiles.length > 0) {
                try {
                    const sealedCertificationFileResponse = await uploadFiles(sealedCertificationFiles, "sealedCertification");
                    const sanitizedNames = sealedCertificationFileResponse.map((file: any) => sanitizeFileName(String(file))).join(", ");
                    setValue("engineerSealedCertificate", sanitizedNames);
                    setValue("engineerSealedCertificatePath", `wwwroot\\SealedCertificationUploads\\`);
                    data = {
                        ...data,
                        engineerSealedCertificate: applicationInspectionData?.engineerSealedCertificate ? applicationInspectionData?.engineerSealedCertificate + ", " + sanitizedNames : sanitizedNames,
                        engineerSealedCertificatePath: `wwwroot\\SealedCertificationUploads\\`
                    };
                } catch (error: any) {
                    const errorMessage = error.message || error.error || 'Failed to upload sealed certification file';
                    toast.error(errorMessage, { autoClose: 5000 });
                    setIsSubmitting(false);
                    return;
                }
            }
            else if (applicationInspectionData?.engineerSealedCertificate) {
                // If no new files are selected but existing files exist, keep the existing data
                data = {
                    ...data,
                    engineerSealedCertificate: applicationInspectionData.engineerSealedCertificate,
                    engineerSealedCertificatePath: applicationInspectionData.engineerSealedCertificatePath || `wwwroot\\SealedCertificationUploads\\`
                };
            }

            if (validate()) {
                try {
                    const result = await onSubmit(data);
                    if (result !== null) {
                        return result;
                    } else {
                        console.log("Form submission was cancelled due to error");
                        return null;
                    }
                } catch (error: any) {
                    const errorMessage = error.message || error.error || 'Form submission failed';
                    toast.error(errorMessage, { autoClose: 5000 });
                    console.error("Form submission error:", error);
                    setIsSubmitting(false);
                    return null;
                }
            } else {
                toast.error("Please fix validation errors before submitting.", { autoClose: 5000 });
                return null;
            }
        } catch (error: any) {
            const errorMessage = error.message || error.error || 'Submission failed';
            toast.error(errorMessage, { autoClose: 5000 });
            console.error("Submission error:", error);
            setIsSubmitting(false);
            return null;
        } finally {
            setIsSubmitting(false);
        }
    };

    const submit = () => {
        try {
            setValue("applicationId", applicationInfoId);
            setValue("applicationInspectionId", inspectionId);
            setValue('dateUpdated', new Date());
            setValue('updatedBy', user?.userName);
            setValue('dateCreated', new Date());
            setValue('createdBy', user?.userName);
            setValue('userId', user?.userSecurityId);
            setValue('providerId', user?.userSecurityId);
            
            // Set the ehdinspectionNumber if available from application inspection data
            if (applicationInspectionData?.ehdinspectionNumber) {
                setValue('ehdinspectionNumber', applicationInspectionData.ehdinspectionNumber);
            }           
 
            if (formRef.current) {
                formRef.current.dispatchEvent(
                    new Event('submit', { cancelable: true, bubbles: true })
                );
            } else {
                toast.error("Form reference not found. Please try again.");
            }
        } catch (error: any) {
            toast.error(`Error preparing form submission: ${error.message || 'Unknown error occurred'}`);
        }
    }

    const fileUploadCallback = usePostFileForm("ApplicationInspection/file?EntityId=" + entityId);

    const uploadFile = async (formData: FormData) => {
        return new Promise((resolve, reject) => {
            fileUploadCallback(formData, (response: any) => {
                if (response && typeof response === 'string') {
                    try {
                        const parsedResponse = JSON.parse(response);
                        if (parsedResponse.success !== false) {
                            resolve(parsedResponse);
                        } else {
                            const errorMessage = parsedResponse?.message || parsedResponse?.error || 'File upload failed';
                            reject(new Error(errorMessage));
                        }
                    } catch {
                        // If response is not JSON, treat it as success
                        resolve(response);
                    }
                } else if (response && response.success !== false) {
                    resolve(response);
                } else {
                    const errorMessage = response?.message || response?.error || 'File upload failed';
                    reject(new Error(errorMessage));
                }
            });
        });
    }



    return (
        <Page.Container>
            <ApplicationDetailsPage id={applicationInfoId}></ApplicationDetailsPage>
            <Page.Header preTitle="" title="Submit Inspection" />
            <div className="container-xl">
                <p>Please submit approval or disapproval of the onsite sewage treatment and disposal system.</p>
            </div>

            <Page.Body>
                <Layout.Container>
                    <form id={props.id} ref={formRef} onSubmit={handleSubmit((data: SubimtInspectionInput) => finalSubmit(data), () => { validate() })}>
                        <div id="inspection">
                            <div className="accordion" id="accordion-example-2">
                                <div className="accordion-item">
                                    <h2 className="accordion-header inspection-header" id="heading-2">
                                        <button className="accordion-button inspection-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-2" aria-expanded="false">
                                            <p className="header-color inspection-header">Summary of Out-of-Compliance Items</p></button>
                                    </h2>
                                    <div id="collapse-2" className="accordion-collapse collapse" data-bs-parent="#accordion-example-2">
                                        <div className="accordion-body pt-0">
                                            <Layout.Row>
                                                <div className="non-complaint-header">
                                                    <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M2.5 2.5L17.5 17.5" stroke="#B43A41" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M15.4478 15.4146C15.8291 15.015 15.8143 14.382 15.4148 14.0007C15.0152 13.6194 14.3822 13.6342 14.0009 14.0338L15.4478 15.4146ZM10.0002 17.5L9.74914 18.468C9.91377 18.5107 10.0866 18.5107 10.2512 18.468L10.0002 17.5ZM2.91688 5L2.962 4.00102C2.50203 3.98024 2.08733 4.27622 1.95747 4.71797L2.91688 5ZM5.04861 5.88211C5.59378 5.7937 5.96405 5.28009 5.87565 4.73493C5.78724 4.18977 5.27364 3.81949 4.72847 3.90789L5.04861 5.88211ZM7.05627 3.22249C6.55231 3.44841 6.32691 4.0401 6.55283 4.54406C6.77874 5.04803 7.37043 5.27343 7.87439 5.04751L7.05627 3.22249ZM10.0003 2.5L10.663 1.75105C10.2846 1.41634 9.71611 1.41632 9.33777 1.75099L10.0003 2.5ZM17.0837 5L18.0431 4.71793C17.9131 4.27599 17.4981 3.97999 17.038 4.00105L17.0837 5ZM15.2865 12.3163C15.0107 12.7948 15.1749 13.4063 15.6533 13.6821C16.1318 13.958 16.7433 13.7938 17.0191 13.3153L15.2865 12.3163ZM14.0009 14.0338C12.8439 15.2461 11.3714 16.1114 9.7492 16.532L10.2512 18.468C12.2339 17.9538 14.0337 16.8963 15.4478 15.4146L14.0009 14.0338ZM10.2513 16.532C7.89226 15.9201 5.88224 14.3777 4.68073 12.2574L2.94068 13.2435C4.4092 15.8349 6.86589 17.7201 9.74914 18.468L10.2513 16.532ZM4.68073 12.2574C3.47922 10.1371 3.18895 7.62018 3.87628 5.28203L1.95747 4.71797C1.1174 7.5757 1.47217 10.652 2.94068 13.2435L4.68073 12.2574ZM2.87175 5.99898C3.59548 6.03167 4.3249 5.99946 5.04861 5.88211L4.72847 3.90789C4.15718 4.00054 3.5666 4.02833 2.962 4.00102L2.87175 5.99898ZM7.87439 5.04751C8.88949 4.59245 9.82968 3.98606 10.6629 3.24901L9.33777 1.75099C8.65605 2.35404 7.8868 2.85018 7.05627 3.22249L7.87439 5.04751ZM9.33771 3.24895C11.4789 5.14332 14.2735 6.12964 17.1294 5.99895L17.038 4.00105C14.7013 4.10797 12.4148 3.30098 10.663 1.75105L9.33771 3.24895ZM16.1243 5.28207C16.8183 7.64276 16.5156 10.1847 15.2865 12.3163L17.0191 13.3153C18.5214 10.71 18.8914 7.60321 18.0431 4.71793L16.1243 5.28207Z" fill="#B43A41" />
                                                    </svg>     <span style={{ fontSize: 20 }}>Non-Compliant</span>        </div>
                                                <div className="content-padding">

                                                    {
                                                        appInspectionCompliance && appInspectionCompliance.map((rowDetails: any, i: any) => {
                                                            return <p style={{ marginBottom: 5, fontSize: 18, marginLeft: 25 }} key={i}>
                                                                <span>{rowDetails.key1}: {rowDetails.keys2}; </span>
                                                                <span>Explanation: {rowDetails.value}</span>
                                                            </p>
                                                        }
                                                        )
                                                    }
                                                </div>
                                            </Layout.Row>
                                        </div>
                                    </div>
                                </div></div></div>
                        <Card.Container>
                            <Card.Body>
                                <Layout.Row>   <>
                                    <div className="row">
                                        <label>Please indicate if the construction is approved.</label>
                                    </div>
                                    <div className="row">
                                        <div className="col col-md-8">
                                            <button type="button" className={`btn ${flag === 'disapprove' ? 'disapprove' : 'normalbtn'}`} onClick={() => toggle('disapprove')} >Disapprove</button>
                                            <button type="button" className={`btn ${flag === 'approve' ? 'approve' : 'normalbtn'}`} onClick={() => toggle('approve')}>Approve</button>
                                        </div>
                                        {/* <div className="col col-md-3">
                            <button className="btn btn-primary">Approve</button>
                            </div>  */}
                                    </div>
                                    <div className="row">
                                        <div className="col col-md-12">
                                            <FormControl.TextArea
                                                control={control}
                                                name="additionalComments"
                                                label="Additional Comments"                                             
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col col-md-6">
                                            <div className="mb-3">
                                                <div className="form-label">Attach File (As-built sketch, soil profile, PPI Authorization, DEP 4015A)</div>
                                                <input type="file" className={`form-control ${!isInspectionFileValid ? 'is-invalid' : ''}`} onChange={(e) => { saveFile(e, "inspection") }}
                                                    name="inspection"
                                                    accept=".pdf,.png,.jpg,.jpeg,.gif,.bmp,.tiff,.tif"
                                                    multiple
                                                    required />
                                                {!isInspectionFileValid && <div className="invalid-feedback">{inspectFileError}</div>}
                                            </div>
                                            <label className="labelfile">Accepts .pdf, .png, .jpg, .jpeg, .gif, .bmp, .tiff, and .tif file types; Maximum size: 10MB. <br/>You may select multiple files. If you are using a desktop, please hold ctrl button and select multiple files at once.</label>
                                        </div>
                                        <div className="col col-md-6">
                                            <div className="mb-3">
                                                <div className="form-label">Attach Engineer Sealed Certification</div>
                                                <input type="file" className={`form-control ${!isSealedCertificationFileValid ? 'is-invalid' : ''}`}
                                                    accept=".pdf,.png,.jpg,.jpeg,.gif,.bmp,.tiff,.tif"
                                                    multiple
                                                    onChange={(e) => { saveFile(e, "sealedCertification") }} name="sealedCertification" />
                                                {!isSealedCertificationFileValid && <div className="invalid-feedback">{sealedCertificationFileError}</div>}
                                            </div>
                                            <label className="labelfile">Accepts .pdf, .png, .jpg, .jpeg, .gif, .bmp, .tiff, and .tif file types; Maximum size: 10MB. <br/>You may select multiple files. If you are using a desktop, please hold ctrl button and select multiple files at once.</label>
                                        </div>
                                    </div>
                                </></Layout.Row>
                                {/* Render alert if at least one file is missing, after both upload blocks */}
                                {atLeastOneFileRequiredError && (
                                    <div className="alert alert-danger" role="alert">
                                        {atLeastOneFileRequiredError}
                                    </div>
                                )}
                            </Card.Body>
                        </Card.Container>
                        {applicationInspectionData?.inspectionStatusId === 3 && (
                            <Card.Container>
                                <Card.Body>
                                    <Card.Title>Attached documents</Card.Title>
                                    <Layout.Row>
                                        <>
                                            <div className="col col-md-2">
                                                <div className="mb-3"><label>Attachments</label></div>
                                            </div>
                                            <div className="col col-md-4">
                                                <div className="mb-3">
                                                    <label> {(applicationInspectionData?.inspectionFileName !== null || applicationInspectionData.engineerSealedCertificate !== null) ? "Yes" : "No"}</label>
                                                </div>
                                            </div>
                                            
                                            <div className="row">
                                                <div className="col col-md-12">
                                                    <div className="mb-3">
                                                        {/* Inspection Files */}
                                                        {applicationInspectionData?.inspectionFileName && applicationInspectionData?.inspectionFilePath && (
                                                            applicationInspectionData.inspectionFileName.split(',').map((fileName: string, idx: number) => {
                                                                const trimmedFileName = fileName.trim();
                                                                // If there are multiple paths, split and match by index, else use the same path for all
                                                                const paths = applicationInspectionData.inspectionFilePath.split(',');
                                                                const filePath = paths.length > 1 ? (paths[idx] ? paths[idx].trim() : paths[0].trim()) : applicationInspectionData.inspectionFilePath.trim();
                                                                return (
                                                                    <li key={`inspection-file-${idx}`}>
                                                                        <a className="text-decoration-underline cursor-pointer"
                                                                            onClick={() => DownloadFile(trimmedFileName, filePath)}>
                                                                            {trimmedFileName}
                                                                        </a>
                                                                    </li>
                                                                );
                                                            })
                                                        )}
                                                        {/* Engineer Sealed Certificate Files */}
                                                        {applicationInspectionData?.engineerSealedCertificate && applicationInspectionData?.engineerSealedCertificatePath && (
                                                            applicationInspectionData.engineerSealedCertificate.split(',').map((fileName: string, idx: number) => {
                                                                const trimmedFileName = fileName.trim();
                                                                const paths = applicationInspectionData.engineerSealedCertificatePath.split(',');
                                                                const filePath = paths.length > 1 ? (paths[idx] ? paths[idx].trim() : paths[0].trim()) : applicationInspectionData.engineerSealedCertificatePath.trim();
                                                                return (
                                                                    <li key={`engineer-file-${idx}`}>
                                                                        <a className="text-decoration-underline cursor-pointer"
                                                                            onClick={() => DownloadFile(trimmedFileName, filePath)}>
                                                                            {trimmedFileName}
                                                                        </a>
                                                                    </li>
                                                                );
                                                            })
                                                        )}

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">

                                            </div>
                                        </>
                                    </Layout.Row>
                                </Card.Body>
                            </Card.Container>
                        )}

                        <Card.Container className="providerCard">

                            <Card.Body>
                                <Card.Title> Provider Details</Card.Title>

                                <Layout.Row>   <>
                                    <div className="row">
                                        <div className="col col-md-4 read-only">

                                            {user && (<FormControl.ReadOnly
                                                //control={control}
                                                name="providerName"
                                                label="Provider Name"
                                                value={user?.lastName + ', ' + user?.firstName}
                                            ></FormControl.ReadOnly>)}

                                            {/* <FormControl.Select
                                    control={control}
                                    name="providerId"
                                    label="Provider Name"
                                    options={ProviderData}

                                    required
                                /> */}


                                        </div>
                                        <div className="col col-md-4">
                                            <FormControl.Date
                                                control={control}
                                                name="inspectionApprovedDate"
                                                label="Inspection Date"
                                                max={today}
                                                //type="date"
                                                min={applicationData?.toString().split("T")[0]}
                                                //min={applicationData?.toDateString()}
                                                required
                                            />
                                            {/* <label>MM/DD/YYYY</label>*/}
                                        </div>
                                    </div>

                                    <div className="row">

                                        <FormControl.Checkbox
                                            control={control}
                                            name="additionalInspectionRequired"
                                            label="An additional private provider inspection is required."
                                        />

                                    </div>
                                    <div className="row">
                                        <FormControl.Checkbox
                                            control={control}
                                            name="penaltyOfLawCheck"
                                            label="Under penalty of law, I hereby certify that I have personally inspected the installation of this onsite sewage treatment and disposal system with the results indicated and that I have
                                    no conflict of interest."
                                            required
                                        />

                                    </div>
                                </></Layout.Row>
                            </Card.Body>

                            <Card.Footer>
                                <div className="d-flex">

                                    <div className="btn-list ms-auto">
                                        <Link
                                            to={`/inspectionDetails/${inspectionId}` || path.current}
                                            className="btn btn-light"
                                            role="button">
                                            Cancel
                                        </Link>
                                        <Button
                                            className="btn btn-primary ms-auto" 
                                            disabled={isSubmitting}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                {
                                                    applicationInspectionData?.inspectionStatusId === 1 && (
                                                        setValue('inspectionStatusId', InspectionStatus.Complete))
                                                }
                                                {
                                                    applicationInspectionData?.inspectionStatusId === 3 && (
                                                        setValue('inspectionStatusId', InspectionStatus.NeedsReview))
                                                }
                                                submit()
                                            }}>
                                            {isSubmitting ? 'Submitting...' : 'Submit'}
                                        </Button>
                                    </div>
                                </div>
                            </Card.Footer>
                        </Card.Container>
                    </form>
                </Layout.Container>
            </Page.Body>
        </Page.Container>
    );
};

export default SubmitInspectionForm;




